const APPROVE = { code: "APR", description: "Approve" };
const DENY = { code: "DNY", description: "Deny" };

export default {
    APPROVE,
    DENY
};


// WEBPACK FOOTER //
// ./src/areas/shared/consts/CommReviewVoteStatus.js